<template>
<section id="video-section">
    <!-- <pattern-symbols class="bg-symbols"></pattern-symbols> -->
    <div id="tagline" class="tagline text-center py-5 py-sm-0">
        <h2 class="display-4 text-white">
            <span>Bridge</span> learning gaps with
            <span class="fredericka text-white"> NextGenMath.com</span>
        </h2>
    </div>
    <div class="video-wrapper-outer">
        <b-container class="video-wrapper">
            <div class="embed-responsive embed-responsive-16by9">
                <lazy-component>
                    <video width="100%" height="100%" controls>
                        <source :src="`${routes.cdn_url}/videos/Home-Page-Explainer-Video.mp4`" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </lazy-component>
            </div>
        </b-container>
    </div>
</section>
</template>

<script>
// import PatternSymbols from '../components/SVGBackgrounds/symbols.svg';

export default {
    // components: {
    //     PatternSymbols,
    // }
}
</script>

<style lang="scss" scoped>
#video-section {
    background-color: #111;
    background-image: url('https://cdn.nextgenmath.com/images/redesign/home/symbols.svg');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    padding-top: 4rem;
    padding-bottom: 3rem;
    margin-bottom: 2rem;

    .fredericka {
        font-family: 'Fredericka the Great', cursive;
        color: #fff;
    }

    .video-wrapper-outer {
        padding-bottom: 5rem;
        .video-wrapper {
            margin-top: 5rem;
            .embed-responsive {
                box-shadow: 4px 4px 24px rgba(0,0,0,.75);
            }
        }
    }
}

// .bg-symbols {
//     width: 100%;
//     position: absolute;
//     right: 0;
// }
</style>
